export const prompt = (message) => {
  return confirm(message)
}
